module.exports = __webpack_public_path__ + "img/anne_dehnert.365696cd.png";